<template>
  <div class="page-content">
    <div class="content-left">
      <div class="title flexStart" style="position:relative;">
        <div class="head">
          <div style="width: 50px;height:50px;">
            <el-avatar :size="50" :src="serviceMessage.imageUrl"></el-avatar>
          </div>
          <div class="serviceState" :style="isOff === 1 ? { backgroundColor: '#67C23A' } : { backgroundColor: '#ececec !important' }" @click="changeState">{{ isOff === 0 ? '离线' : '在线' }} </div>
        </div>
        <div class="autoClose">{{ serviceMessage.name }}</div>
      </div>
      <div class="search">
        <el-input placeholder="搜索最近联系人" suffix-icon="el-icon-search" v-model="name" @change="customerServiceList">
        </el-input>
      </div>
      <div class="listTab">
        <el-tabs v-model="typeName" ref="myTabs" type="card" :stretch="true" @tab-click="customerServiceList()">
          <el-tab-pane :name="'0'">
            <div slot="label" style="position:relative;"><i class="el-icon-user"></i>已接入</div>
            <div class="peopleList" v-loaing="peopleListLoading">
              <el-empty description="暂无接入客户" v-if="peopleList == null || peopleList.length == 0"></el-empty>
              <div v-else class="flexStart" :class="{ isSelect: selectId == a.id }" style="padding:10px;" v-for="(a, i) in peopleList" :key="i" @click="selectId = a.id, selectUser(a)">
                <div style="width: 50px;height:50px;position: relative;">
                  <div class="delete" v-if="a.userState == 0"></div>
                  <el-avatar :size="50" :src="a.appAvatar ? a.appAvatar : appAvatar"></el-avatar>
                </div>
                <div style="margin-left: 10px;flex: 1;">
                  <div style="min-width:200px;" class="flex">
                    <div class="name">{{ a.nickname }}</div>
                    <div class="time">{{ a.finallySendTime }}</div>
                  </div>
                  <div class="message">{{ a.finallySendContentType == 0 ? a.finallySendContent : a.finallySendContentType == 3 ? '[订单]' : '[图片]' }} </div>
                  <div class="dot-people" v-if="a.msgState == 0"></div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :name="'1'">
            <div slot="label" style="position:relative;"><i class="el-icon-user-solid"></i>离线未接 <div class="dot" v-if="offlineMissedConnectionNum > 0"></div>
            </div>
            <div class="peopleList" v-loaing="peopleListLoading">
              <el-empty description="暂无离线未接客户" v-if="peopleList == null || peopleList.length == 0"></el-empty>
              <div v-else class="flexStart" :class="{ isSelect: selectId == a.id }" style="padding:10px;" v-for="(a, i) in peopleList" :key="i" @click="selectId = a.id, selectUser(a)">
                <div style="width: 50px;height:50px;position: relative;">
                  <div class="delete" v-if="a.userState == 0"></div>
                  <el-avatar :size="50" :src="a.appAvatar ? a.appAvatar : appAvatar"></el-avatar>
                </div>
                <div style="margin-left: 10px;flex: 1;">
                  <div style="min-width:200px;" class="flex">
                    <div class="name">{{ a.nickname }}</div>
                    <div class="time">{{ a.finallySendTime }}</div>
                  </div>
                  <div class="message">{{ a.finallySendContentType == 0 ? a.finallySendContent : '[图片]' }}</div>
                  <div class="dot-people" v-if="a.msgState == 0"></div>
                  <div style="float:right;font-size: 12px;color:#aaa;">未读({{ a.messageNotConnected }})</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="content-center">
      <div v-if="selectId != 0" v-loading="chatLoading">
        <div class="title">{{ userData.nickname }}</div>
        <div class="message-box">
          <div style="flex:1;overflow:auto;" class="box">
            <div v-for="(v, i) in serviceList" :key="i">
              <div class="flexStart" style="margin-top: 10px;" v-if='v.receiveType === 0'>
                <div style="width: 50px;height:50px;">
                  <el-avatar :size="50" :src="userData.appAvatar ? userData.appAvatar : appAvatar"></el-avatar>
                </div>
                <div style="margin-left: 10px;">
                  <div class="flexStart">
                    <!-- 文本 -->
                    <div class="content" v-if="v.messageType == 0">{{ v.content }}</div>
                    <!-- 收到的图片 -->
                    <el-image :src="v.content" mode="widthFix" style="width: 214px;border-radius: 20px;" :preview-src-list="[v.content]" v-if="v.messageType == 1">
                    </el-image>
                    <video :src="v.content" style="width: 214px;border-radius: 20px;" v-if="v.messageType == 2"></video>
                    <!-- 订单 -->
                    <div class="order-list-item" style="min-width: 260px;background: #FFFFFF;padding: 16px 14px;" v-if="v.messageType == 3">
                      <div class="flex" style="border-bottom:1px solid #F7F7F7;padding-bottom: 12px;font-size: 12px;">
                        <div style="color: #999999;">订单号：{{ v.orderData.orderNo }}</div>
                        <div style="color: #DA1515;" v-if="v.orderData.orderStatus == 'SUBMITTED'">新订单</div>
                        <div style="color: #DA1515;"
                          v-else-if="v.orderData.orderStatus == 'CONFIRMED' || v.orderData.orderStatus == 'PROCESSING' || v.orderData.orderStatus == 'RENDER_DONE' || v.orderData.orderStatus == 'DONE_DOWNLOAD'">
                          待发货 </div>
                        <div style="color: #DA1515;" v-else-if="v.orderData.orderStatus == 'SHIPPED'">待收货</div>
                        <div style="color: #DA1515;" v-else-if="v.orderData.orderStatus == 'COMPLETED'">已完成</div>
                        <div style="color: #DA1515;" v-else-if="v.orderData.orderStatus == 'CANCELLED'">已取消</div>
                        <div style="color: #DA1515;" v-else-if="v.orderData.orderStatus == 'AFTERSALESED'">已售后</div>
                      </div>
                      <div class="flex">
                        <el-image :src="v.orderData.skuGroupImage" mode="scaleToFill" style="width: 54px;height: 54px;border-radius:6px;"></el-image>
                        <div style="flex:1;padding-left: 10px;">
                          <div class="flex" style="color: #333333;font-size: 14px;">
                            <span>{{ v.orderData.spuName }}</span><span style="padding-left: 20px;">￥{{ v.orderData.cprice }}</span>
                          </div>
                          <div class="flex" style="color: #999999;margin-top: 5px; font-size: 12px; ">
                            <span>{{ v.orderData.dictSetStr }}</span><span>×{{ v.orderData.quantity }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="time">{{ v.createTime }}</div>
                  </div>
                  <!--                  <div style="font-size: 12px;color:#aaa;margin-top: 0px;"> {{ v.status == 2 ? '已读' : '未读' }}</div>-->
                </div>
              </div>
              <div class="flexEnd" style="margin-top: 10px;" v-if="v.receiveType === 1">
                <div style="margin-right: 10px;display: flex;flex-direction: column;align-items: flex-end;">
                  <div style="font-size: 13px;color:#666;">{{ v.customerServiceName }}</div>
                  <div class="flexStart" style="margin-top: 10px;">
                    <div class="time" style="margin-right: 10px;">{{ v.createTime }}</div>
                    <!-- 文本 -->
                    <div class="content" style="background-color: #e1efff;" v-if="v.messageType == 0">{{ v.content }} </div>
                    <!-- 图片 -->
                    <el-image :src="v.content" mode="widthFix" :preview-src-list="[v.content]" style="width: 114px;border-radius: 20px;" v-if="v.messageType == 1">
                    </el-image>
                  </div>
                  <!--                  <div style="font-size: 12px;color:#aaa;margin-top: 0px;float:right;">-->
                  <!--                    <i class="el-icon-loading" v-if="v.loading"></i> {{ v.status == 2 ? '已读' : '未读' }}-->
                  <!--                  </div>-->
                </div>
                <div style="width: 50px;height:50px;margin-top: 30px;">
                  <el-avatar :size="50" :src="v.headSculpture"></el-avatar>
                </div>
              </div>
            </div>
          </div>
          <!-- <picker set="emojione" v-if="showPicke" style="z-index:999;position: absolute;" /> -->
          <div class="input-box" style="z-index:100">
            <div class="flexStart input-icon">
              <!--              <i class="el-icon-picture-outline-round" style="font-size: 25px;color:#aaa" @click="showPicke = true"></i>-->
              <el-upload :disabled="sendButtonState" class="avatar-uploader" :limit="10" :multiple="true" :on-exceed="uploadExeced" :show-file-list="false" :before-upload="beforeAvatarUpload"
                :http-request="(e) => uploadAppImage(e)">
                <i class="el-icon-picture-outline" style="font-size: 25px;color:#aaa"></i>
              </el-upload>
              <!--              <el-upload class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess"-->
              <!--                         :before-upload="beforeAvatarUpload" :on-progress="uploadVideoProcess">-->
              <!--                <i class="el-icon-video-camera" style="font-size: 25px;color:#aaa"></i>-->
              <!--              </el-upload>-->
            </div>
            <el-input style="margin-top:10px;" type="textarea" :rows="5" placeholder="请输入内容" v-model="msgContent" show-word-limit maxlength="500" :disabled="sendButtonState"
              @keyup.enter.native="sendMessage(0)">
            </el-input>
            <div class="flexEnd">
              <!-- <div>{{ `${textarea.split().length - 1} / 500` }}</div> -->
              <el-button :type="isOff === 1 ? 'primary' : ''" style="margin-left: 10px;" @click="isOff === 1 ? sendMessage(0) : ''" :disabled="sendButtonState">发送 </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right">
      <div v-if="selectId != 0">
        <div style="padding: 10px;">
          <el-input placeholder="输入关键词搜索短语" suffix-icon="el-icon-search" v-model="searchFastLanguage" clearable @change="searchFastLanguage ? getByQuickMsgList() : getQuickMsgList()">
          </el-input>
        </div>
        <el-tabs v-model="kuaijie">
          <el-tab-pane label="快捷短语" :name="1">
            <el-collapse v-model="activeNames" @change="handleChange" v-if="!isSearch">
              <el-collapse-item v-for="(a, i) in quickMsgLists" @mouseout="showId = 0" :title="a.name + `(${a.contextList.length})`" :name="a.code" :key="i">
                <div class="list-item" v-for="(item, index) in a.contextList" :key="index">
                  <div class="list-item flex" @mouseenter="showId = item.id">
                    <el-tooltip class="item" effect="dark" :content="item.context" placement="top">
                      <div style="flex: 1;" class="limit-length">{{ item.context }}</div>
                    </el-tooltip>
                    <div class="action flex" style="float: right;" @mouseout="showId = 0" v-if="showId == item.id">
                      <div @click="deleteItemMsg(item.id)">删除</div>
                      <div @click="addQuickMsg(item, a.code)">编辑</div>
                      <div @click="phraseSendMessage(item.context)" v-if="!sendButtonState">发送</div>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <div v-else>
              <div class="list-item" v-for="(item, index) in selectList" :key="index">
                <div class="list-item flex" @mouseenter="showId = item.id">
                  <el-tooltip class="item" effect="dark" :content="item.context" placement="top">
                    <div style="flex: 1;" class="limit-length">{{ item.context }}</div>
                  </el-tooltip>
                  <div class="action flex" style="float: right;" @mouseout="showId = 0" v-if="showId == item.id">
                    <div @click="deleteItemMsg(item.id)">删除</div>
                    <div @click="addQuickMsg(item, item.msgTypeCode)">编辑</div>
                    <div @click="phraseSendMessage(item.context)" v-if="!sendButtonState">发送</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="addQuickMsg" @click="addQuickMsg">新建快捷短语</div>
      </div>
      <el-dialog title="新增" :visible.sync="dialogVisible" width="50%" v-if="dialogVisible">
        <el-form ref="fastMsg" label-width="160px" :model="msgForm" :rules="rules" class="demo-form-inline">
          <el-form-item label="短语内容：" prop="context">
            <el-input type="textarea" :rows="5" placeholder="请输入短语内容" v-model="msgForm.context" maxlength="500" show-word-limit style="width:400px !important;" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="选择分组：" prop="group">
            <el-select v-model="msgForm.msgTypeCode" placeholder="请选择类型" style="width:400px !important;" clearable>
              <!-- <el-option label="类" value="CATEGORY"></el-option> -->
              <el-option v-for="(v, i) in fastLanguageType" :label="v.name" :value="v.code" :key="i"></el-option>
              <!-- <el-option label="sku" value="SKU"></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button round @click="dialogVisible = false">取消</el-button>
          <el-button round type="primary" @click="save()">保存</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import appAvatar from '../../assets/images/head-logo.png'
import head from '../../assets/images/cord.jpg'
import { getInfoByType, queryByQuickMsg, quickMsgAdd, deleteInfoById, quickMsgList, quickMsgEdit } from '@/api/crm'
import {
  accessingCustomers,
  chatHistory,
  customerServiceList,
  downLive,
  findWsUrl,
  getStatus,
  goLive, offlineMissedConnection, sendImageMessage,
  sendMessage
} from '@/views/Service/chatApi'
import { orderSuborderInfo } from '@/api/oms'

export default {
  name: 'chat-window',
  data () {
    return {
      appAvatar,
      isOff: true, // 是否下线
      showPicke: false,
      serviceList: [],
      itemOrder: {
        orderNumber: '564654684894456',
        orderState: '待发货',
        prodName: '前程似锦台历',
        cprice: '35',
        num: 1,
        prodSku: '工艺纸'
      },
      showDialog: true,
      isSearch: false,
      selectList: [],
      msgContent: '',
      showId: 0,
      kuaijie: 1,
      dialogVisible: false,
      searchFastLanguage: '',
      selectId: 0,
      customerId: 0,
      textarea: '',
      head: head,
      fastLanguageType: [],
      peopleList: [],
      peopleListLoading: false,
      msgForm: {
        context: '',
        msgTypeCode: ''
      },
      quickMsgLists: [],
      serviceMessage: {},
      userId: null,
      userType: 2,
      wsurl: null,
      websock: null,
      hasLogin: false,
      isConnect: false,
      timeoutObj: null,
      rec: null,
      userData: null,
      chatLoading: false,
      typeName: '0',
      sendMessageData: {
        chatMessagesId: null,
        receiveType: 1,
        sendId: null,
        content: null,
        type: 1,
        messageType: 0,
        customerServiceId: null,
        customerServiceName: null,
        headSculpture: null,
        uuid: null,
        loading: null,
        offlineMissedConnectionNum: 0
      },
      name: null,
      awsSdk: {},
      sendButtonState: false
    }
  },
  async created () {
    this.awsSdk = JSON.parse(this.$route.query.awsSdk)
    this.serviceMessage = this.$store.state.user.serviceMsg
    if (!this.serviceMessage) {
      // 用户未登录
      this.$confirm('用户未登录，请您登陆!', '提示', {
        confirmButtonText: '确定',
        type: 'error',
        showClose: false,
        showCancelButton: false
      }).then(() => {
        window.close()
      })
    }
    this.customerId = this.serviceMessage.id
    this.userId = localStorage.getItem('userId')
    this.sendMessageData.customerServiceId = this.userId
    this.sendMessageData.customerServiceName = this.serviceMessage.name
    this.sendMessageData.headSculpture = this.serviceMessage.imageUrl
    await this.getInfoByTypeList()
    this.getQuickMsgList()
  },
  mounted () {
    // 进入页面自动上线
    this.goLive()
    // 连接通讯
    this.openWS()
  },
  beforeDestroy () {
    clearTimeout(this.rec)
    clearTimeout(this.timeoutObj)
    this.isConnect = false
  },
  methods: {
    // 获取离线未接数量
    offlineMissedConnection () {
      offlineMissedConnection().then(res => {
        this.offlineMissedConnectionNum = res.data
      })
    },
    goLive () {
      let that = this
      // 调用上线接口处理逻辑
      goLive(this.userId).then(res => {
        that.getStatus()
        that.customerServiceList()
        // 获取离线未接数量
        that.offlineMissedConnection()
      })
    },
    scrollBtm () {
      const box = document.querySelector('.box')
      box.scrollTop = box.scrollHeight
      // box.scrollTop = box.scrollHeight - box.clientHeight
      box.addEventListener('DOMNodeInserted', () => {
        box.scrollTop = box.scrollHeight
      })
    },
    // 切换在线离线
    changeState () {
      this.$confirm(`是否确认${this.isOff === 0 ? '上线' : '下线'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.isOff == 1) {
          // 下线操作
          await downLive(this.userId).then(res => {
            this.offlineMissedConnection()
          })
          // this.closeWS()
          this.isOff = 0
          this.msgContent = null
          this.sendButtonState = true
        } else {
          this.openWS()
          // 上线操作
          this.goLive(this.userId)
          this.isOff = 1
        }
        this.customerServiceList(this.userId, this.typeName)
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    // 开启通讯
    async openWS () {
      let data = await findWsUrl()
      if (!data) {
        // 连接断开修改标识
        this.isConnect = false
        this.reConnectWs()
      } else {
        this.wsurl = 'ws://' + data.ip + ':' + data.port + '/im'
        if (!this.wsurl) {
          // 连接断开修改标识
          this.isConnect = false
          this.reConnectWs()
        } else {
          this.websock = new WebSocket(this.wsurl)
          this.initWsFun()
        }
      }
    },
    // 初始化WS
    initWsFun () {
      let that = this
      this.websock.onmessage = function (e) {
        let sendInfo = JSON.parse(e.data)
        if (sendInfo.cmd == 0) {
          that.hasLogin = true // 设置登陆成功状态
          that.startHeartbeat()
        } else if (sendInfo.cmd == 1) {
          // 重新开启心跳定时
          that.resetHeartbeat()
        } else if (sendInfo.cmd == 2) {
          that.$confirm('检查到客服已在其他电脑网站打开!', '提示', {
            confirmButtonText: '确定',
            type: 'error',
            showClose: false,
            showCancelButton: false
          }).then(() => {
            window.close()
          })
        } else if (sendInfo.cmd == 3) {
          if (sendInfo.data.accessType === 2) { // 其他客服下线转接客户
            if (that.typeName === '0') {
              let dataList = JSON.parse(sendInfo.data.content)
              dataList.data.forEach(d => {
                that.peopleList.push(d)
              })
            }
            that.offlineMissedConnection()
          } else if (sendInfo.data.accessType === 1) { // 其他客服接入离线未接客户
            let data = JSON.parse(sendInfo.data.content)
            if (that.typeName === '1') {
              for (let i = 0; i < that.peopleList.length; i++) {
                if (that.peopleList[i].id == data.chatMessageId) {
                  that.peopleList.splice(i, 1)
                }
              }
            }
            that.offlineMissedConnection()
          } else if (sendInfo.data.accessType === 3) { // 用户发信息小红点
            let data = JSON.parse(sendInfo.data.content)
            if (that.typeName === '0') {
              if (that.sendMessageData.chatMessagesId != sendInfo.data.content) {
                // 放入第一个
                for (let i = 0; i < that.peopleList.length; i++) {
                  if (that.peopleList[i].id == data.id) {
                    let item = that.peopleList.splice(i, 1)[0] // 从数组中移除该项并获得它
                    that.peopleList.unshift(item) // 将该项插入到数组的开头
                    break
                  }
                }
                if (that.sendMessageData.chatMessagesId != data.id) {
                  that.peopleList[0].msgState = 0
                  that.peopleList[0].finallySendContent = data.content
                  that.peopleList[0].finallySendTime = data.date
                  that.peopleList[0].finallySendContentType = data.messageType
                } else {
                  that.peopleList[0].finallySendContent = data.content
                  that.peopleList[0].finallySendTime = data.date
                  that.peopleList[0].finallySendContentType = data.messageType
                }
              }
              if (that.isOff == 0) {
                that.offlineMissedConnectionNum += 1
              }
            } else {
              that.peopleList.forEach(p => {
                if (p.id == data.id) {
                  p.messageNotConnected += 1
                  p.finallySendContent = data.content
                  p.finallySendTime = data.date
                  p.finallySendContentType = data.messageType
                }
              })
              that.offlineMissedConnectionNum += 1
            }
          } else if (sendInfo.data.accessType === 4) { // 用户上线
            that.peopleList.forEach(p => {
              if (p.sendUserId == sendInfo.data.content) {
                p.userState = 1
              }
            })
          } else if (sendInfo.data.accessType === 5) { // 用户下线
            that.peopleList.forEach(p => {
              if (p.sendUserId == sendInfo.data.content) {
                p.userState = 0
              }
            })
          } else {
            // 收到的消息
            if (that.sendMessageData.chatMessagesId == sendInfo.data.chatMessageId) {
              if (sendInfo.data.messageType == 3) {
                orderSuborderInfo(sendInfo.data.content).then(res => {
                  let info = {
                    orderNo: res.data.data.order.orderNo,
                    orderStatus: res.data.data.order.orderStatus,
                    spuName: res.data.data.spuName,
                    cprice: res.data.data.cprice,
                    quantity: res.data.data.quantity,
                    dictSetStr: res.data.data.dictSetStr,
                    skuGroupImage: res.data.data.skuGroupImage
                  }
                  sendInfo.data.orderData = info
                  that.serviceList.push(sendInfo.data)
                })
              } else {
                that.serviceList.push(sendInfo.data)
                that.scrollBtm()
              }
            }
          }
        }
      }
      // 设置登陆
      this.websock.onopen = function () {
        that.isConnect = true
        // 发送登录命令
        let loginInfo = {
          cmd: 0,
          data: {
            userId: that.userId,
            userType: that.userType
          }
        }
        that.websock.send(JSON.stringify(loginInfo))
      }
      // 设置关闭
      this.websock.onclose = function (e) {
        // 断开后修改标识
        that.isConnect = false
        // 下线
        // that.reConnectWs()
      }
      // 连接发生错误的回调方法
      this.websock.onerror = function () {
        // 连接断开修改标识
        that.isConnect = false
        that.reConnectWs()
      }
    },
    // 开始请求发送心跳
    startHeartbeat () {
      if (this.isConnect) {
        let heartBeat = {
          cmd: 1,
          data: {
            userId: this.userId,
            userType: this.userType
          }
        }
        this.websock.send(JSON.stringify(heartBeat))
      }
    },
    // 定时发送心跳
    resetHeartbeat () {
      let that = this
      clearTimeout(this.timeoutObj)
      this.timeoutObj = setTimeout(function () {
        that.startHeartbeat()
      }, 5000)
    },
    // 重连
    reConnectWs () {
      let that = this
      // 如果已经连上就不在重连了
      if (this.isConnect) return
      this.rec && clearTimeout(this.rec)
      // 延迟1秒重连  避免过多次过频繁请求重连
      this.rec = setTimeout(function () {
        that.openWS()
      }, 5000)
    },
    // 关闭socket
    closeWS () {
      this.websock.close()
      // this.websock = null
    },
    // 查询客户聊天室
    customerServiceList () {
      this.peopleListLoading = true
      if (this.name == '') {
        this.name = null
      }
      customerServiceList(this.userId, this.typeName, this.name).then(async res => {
        this.peopleList = res.data
        this.offlineMissedConnection()
        this.peopleListLoading = false
      })
    },
    switchTab () {
      this.typeName = '0'
      this.customerServiceList()
    },
    // 点击选择联系人
    async selectUser (val) {
      if (this.typeName === '1') {
        if (this.isOff === 0) {
          this.sendButtonState = true
        } else {
          // 调用接入接口
          let res = await accessingCustomers(val.id, this.userId)
          if (res.code == 200) {
            this.switchTab()
          } else {
            this.$message.error(res.msg)
            return
          }
          this.sendButtonState = false
        }
      }
      // 开启loading
      this.chatLoading = true
      // 设置参数
      this.sendMessageData.sendId = val.sendUserId
      this.sendMessageData.chatMessagesId = val.id
      this.sendMessageData.content = null
      this.sendMessageData.uuid = null
      this.sendMessageData.loading = null
      this.msgContent = null
      this.userData = val
      chatHistory(val.id).then(async res => {
        res.data = res.data == undefined ? [] : res.data
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].messageType == 3) {
            let infoRes = await orderSuborderInfo(res.data[i].content)
            let info = {
              orderNo: infoRes.data.data.order.orderNo,
              orderStatus: infoRes.data.data.order.orderStatus,
              spuName: infoRes.data.data.spuName,
              cprice: infoRes.data.data.cprice,
              quantity: infoRes.data.data.quantity,
              dictSetStr: infoRes.data.data.dictSetStr,
              skuGroupImage: infoRes.data.data.skuGroupImage
            }
            res.data[i].orderData = info
          }
        }
        this.serviceList = !res.data ? [] : res.data
        this.chatLoading = false
        this.scrollBtm()
      })
      this.peopleList.forEach(p => {
        if (p.id == val.id) {
          p.msgState = 1
        }
      })
      this.offlineMissedConnection()
    },
    // 发送消息
    sendMessage (messageType) {
      console.log('(/^ *$/.test(that.msgContent))', this.msgContent)
      let that = this
      if (!that.msgContent || (/^ *$/.test(that.msgContent))) {
        console.log('111111')
        // that.$message.error('请输入发送消息内容！')
        return
      }
      let msgContent = that.msgContent
      let uid = that.generateUUID()
      that.sendMessageData.content = that.msgContent
      that.msgContent = null
      that.sendMessageData.uuid = uid
      that.sendMessageData.loading = true
      that.sendMessageData.type = 0
      that.sendMessageData.messageType = 0
      that.sendMessageData.createTime = that.formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
      let obj = JSON.parse(JSON.stringify(that.sendMessageData))
      that.serviceList.push(obj)
      that.messageType = messageType
      sendMessage(that.sendMessageData).then(res => {
        that.serviceList.forEach(s => {
          if (s.uuid == uid) {
            s.uuid = null
            s.id = res.data
            s.loading = false
          }
        })
        that.peopleList.forEach(p => {
          if (p.id == that.sendMessageData.chatMessagesId) {
            p.finallySendContent = msgContent
            p.finallySendTime = that.formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
          }
        })
      })
    },
    // 发送图片
    uploadAppImage (e) {
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过5M')
        return
      }
      const reader = new FileReader()
      let that = this
      // 设置文件加载完成后的回调函数
      reader.onload = (event) => {
        // event.target.result 包含了文件的内容，可以将其用作预览
        const previewUrl = event.target.result
        let uid = that.generateUUID()
        that.sendMessageData.uuid = uid
        that.sendMessageData.loading = true
        that.sendMessageData.createTime = that.formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        that.sendMessageData.type = 1
        that.sendMessageData.messageType = 1
        that.sendMessageData.content = previewUrl
        let obj = JSON.parse(JSON.stringify(that.sendMessageData))
        that.serviceList.push(obj)
        that.sendMessageData.content = ''
        // 构建数据
        var formdata = new FormData()
        formdata.append('file', e.file)
        formdata.append('vo', JSON.stringify(that.sendMessageData))
        // 开始上传
        sendImageMessage(formdata).then(res => {
          that.serviceList.forEach(s => {
            if (s.uuid == uid) {
              s.uuid = null
              s.id = res.data
              s.loading = false
            }
          })
          that.peopleList.forEach(p => {
            if (p.id == that.sendMessageData.chatMessagesId) {
              p.finallySendContent = that.sendMessageData.content
              p.finallySendContentType = 1
              p.finallySendTime = that.formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
            }
          })
        })
      }
      reader.readAsDataURL(e.file)
    },
    getStatus () {
      getStatus(this.userId).then(res => {
        this.isOff = res.data?.onlineOrNot
      })
    },
    // 上传视频进度条
    uploadVideoProcess (event, file, fileList) {
      this.loadProgress = Math.floor(event.percent)
      if (this.loadProgress >= 100) {
        this.loadProgress = 100
        // setTimeout(() => { this.progressFlag = false }, 1000) // 一秒后关闭进度条
      }
    },
    // 文件上传之前做处理
    beforeUploadVideo (file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'].indexOf(file.type) === -1) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传视频大小不能超过10MB哦!')
        return false
      }
      // 获取视频时长
      var url = URL.createObjectURL(file)
      var audioElement = new Audio(url)
      var duration
      audioElement.addEventListener('loadedmetadata', function (_event) {
        duration = audioElement.duration // 时长为秒，小数，182.36
        this.$parent.$data.wDuration = parseInt(duration)
      })
      new Promise(function (resolve, reject) {
        const _URL = window.URL || window.webkitURL
        const videoElement = document.createElement('video')
        // 当指定的音频/视频的元数据已加载时，会发生 loadedmetadata 事件。 元数据包括：时长、尺寸（仅视频）以及文本轨道。
        videoElement.addEventListener('loadedmetadata', function (_event) {
          const duration = videoElement.duration // 视频时长
          let valid = Math.floor(duration) <= 4
          if (valid) {
            resolve(0)
          } else {
            Promise.reject(new Error('error'))
          }
        })
        videoElement.src = _URL.createObjectURL(file)
      }).then(() => {
        // this.uploadImg(file) // 调用上传接口
      }, () => {
        this.$message.error('上传的视频时长过大，请重新上传')
        return Promise.reject(new Error('上传的视频时长过大'))
      })
    },
    uploadExeced () {
      this.$message.error('最多发送10张!')
    },
    // 发送图片
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isJPG) {
        this.$message.error('图片格式不准确!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }
      return isJPG && isLt2M
    },
    addQuickMsg (val, code) {
      this.dialogVisible = true
      if (val.id) {
        delete val.createTime
        delete val.updateTime
        this.msgForm = {
          ...val,
          msgTypeCode: code.toString()
        }
      }
    },
    // 快捷短语发送
    phraseSendMessage (item) {
      this.msgContent = item
      this.sendMessage(0)
    },
    async getByQuickMsgList () {
      let params = {
        context: this.searchFastLanguage,
        customerId: this.customerId
      }
      await queryByQuickMsg(params).then(res => {
        if (res.data.success) {
          this.isSearch = true
          this.selectList = res.data.data
        } else {
          this.isSearch = false
          this.selectList = []
        }
      })
    },
    getQuickMsgList () {
      this.isSearch = false
      this.selectList = []
      quickMsgList(this.customerId).then(res => {
        if (res.data.success) {
          this.quickMsgLists = res.data.data
        }
      })
    },
    async getInfoByTypeList () {
      await getInfoByType().then(res => {
        if (res.data.success) {
          this.fastLanguageType = res.data.data
        }
      })
    },
    handleClick (val) {
      this.getByQuickMsgList()
    },
    deleteItemMsg (id) {
      this.$confirm('是否确定删除该提示语?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteInfoById(id).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.getQuickMsgList()
          }
        })
      })
    },
    save () {
      if (!this.msgForm.context) {
        this.$message.error('请输入内容')
        return
      }
      if (!this.msgForm.msgTypeCode) {
        this.$message.error('请选择分组')
        return
      }
      let param = {
        ...this.msgForm,
        customerId: this.customerId
      }
      if (this.msgForm.id) {
        quickMsgEdit(param).then(res => {
          if (res.data.success) {
            this.$message.success('成功')
            this.dialogVisible = false
            this.msgForm = {
              context: '',
              msgTypeCode: ''
            }
            this.getQuickMsgList()
          }
        })
      } else {
        quickMsgAdd(param).then(res => {
          if (res.data.success) {
            this.dialogVisible = false
            this.msgForm = {
              context: '',
              msgTypeCode: ''
            }
            this.getQuickMsgList()
          }
        })
      }
    },
    formatDateTime (date, format) {
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
        a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
        A: date.getHours() < 12 ? 'AM' : 'PM' // AM/PM
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
          )
        }
      }
      return format
    },
    generateUUID () {
      let d = new Date().getTime()
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return uuid
    }
  }
}
</script>
<style scoped lang="less">
.page-content {
  height: 100%;
  width: 100%;
  margin: auto;
  display: flex;

  .content-left {
    width: 20%;
    height: 100%;

    /deep/ .el-tabs--border-card>.el-tabs__content {
      padding: 0 !important;
    }

    .title {
      padding: 20px;

      .autoClose {
        font-size: 17px;
        margin-left: 10px;
      }

      .serviceState {
        line-height: 20px;
        width: 50px;
        height: 20px;
        text-align: center;
        position: absolute;
        bottom: 10px;
        color: #fff;
        background-color: #67C23A;
        font-size: 12px;
        border-radius: 2px;
      }

      .offLine {
        background-color: #ececec !important;
        color: #666 !important;
      }
    }

    .search {
      padding: 20px;
      border-top: 1px solid #ececec;
      border-bottom: 1px solid #ececec;
    }

    .peopleList {
      padding-right: 5px;
      overflow: auto;
      height: calc(100vh - 230px);

      .isSelect {
        background: #ececec;
      }

      .time {
        color: #666;
      }

      .message {
        font-size: 16px;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 200px;
      }
    }
  }

  .content-center {
    flex: 1;
    height: 100%;
    border-right: 1px solid #ececec;
    border-left: 1px solid #ececec;

    .title {
      padding: 22px;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #ececec;
      font-size: 18px;
    }

    .message-box {
      padding: 10px;
      background-color: #ececec;
      height: calc(100vh - 115px);
      position: relative;
      display: flex;
      flex-direction: column;
    }

    .content {
      background-color: #fff;
      padding: 10px 20px;
      border-radius: 6px;
      max-width: 300px;
      word-wrap: break-word;
      // height: calc(100vh - 200px);
    }

    .time {
      margin-left: 20px;
    }

    .input-box {
      width: 98%;
      height: 200px;
      border-radius: 6px;
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;

      .input-icon {
        i {
          font-size: 25px;
          color: #aaa;
          margin-left: 10px;
        }
      }

      /deep/ .el-textarea__inner {
        border: 1px solid #fff !important;
      }
    }
  }

  .content-right {
    width: 20%;
    height: 100%;
    position: relative;

    .el-tab-pane {
      padding-left: 10px;
    }

    /deep/ .el-tabs__header {
      padding-left: 10px !important;
    }

    /deep/ .el-tabs__content {
      height: calc(100vh - 200px) !important;
      overflow: auto;
    }

    .list-item {
      border-top: 1px solid #ececec;
      background-color: #ececec;
      line-height: 50px;
      padding: 0 10px;

      .action {
        float: right;
        box-shadow: -3px 0 0 0 rgba(163, 160, 160, 0.12);

        div {
          margin-left: 10px;
          color: #1473e6;
        }
      }
    }

    .addQuickMsg {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      line-height: 50px;
      border-top: 1px solid #ececec;
      color: #1473e6;
      font-size: 16px;
    }
  }
}

/deep/ .el-input {
  width: 100% !important;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex1 {
  display: flex;
  justify-content: space-between;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexStart {
  display: flex;
  justify-content: flex-start;
  // align-items: center;
}

.flexEnd {
  display: flex;
  justify-content: flex-end;
  // align-items: center;
}

.flexAround {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.flexWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.flexWrapStart {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

/* 单行超出显示··· */
.limit-length {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dot {
  width: 8px;
  height: 8px;
  background: #F56D6D;
  border-radius: 50%;
  margin-right: 10px;
  position: absolute;
  right: 0;
  top: 5px;
}

.dot-people {
  width: 8px;
  height: 8px;
  background: #F56D6D;
  border-radius: 50%;
  float: right;
}

.delete {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #f9f7f7;
  z-index: 10;
  opacity: 50%;
  border-radius: 50%;
}

.el-avatar {
  /deep/ img {
    width: 100%;
  }
}
</style>
